export default {
    methods: {
        isTaskOverdue(task) {
            if (task.deadline) {
                let deadline = moment.utc(task.deadline).tz(window.itgTimezone);
                return deadline.isBefore(moment()) && !task.completed_at;
            } else {
                return false;
            }
        }
    },

    computed: {
        alertMinutesBeforeDeadlineOptions() {
            let options = [
                {
                    value: null,
                    label: 'No alert'
                },
                {
                    value: 5,
                    label: '5 minutes'
                },
                {
                    value: 10,
                    label: '10 minutes'
                },
                {
                    value: 20,
                    label: '20 minutes'
                },
                {
                    value: 30,
                    label: '30 minutes'
                },
                {
                    value: 60,
                    label: '1 hour'
                },
                {
                    value: 60 * 2,
                    label: '2 hours'
                },
                {
                    value: 60 * 3,
                    label: '3 hours'
                },
                {
                   value: 60 * 4,
                   label: '4 hours'
                },
                {
                    value: 60 * 5,
                    label: '5 hours'
                }
            ];
            return options;
        }
    }
}
